// AUTO-GENERATED by scripts/generate-register-modules.mjs — do not edit by hand
import enactivity_logs from '../locales/en/modules/activity-logs.json';
import elactivity_logs from '../locales/el/modules/activity-logs.json';
import enapp_status from '../locales/en/modules/app_status.json';
import elapp_status from '../locales/el/modules/app_status.json';
import enclient_contacts from '../locales/en/modules/client-contacts.json';
import elclient_contacts from '../locales/el/modules/client-contacts.json';
import enclients from '../locales/en/modules/clients.json';
import elclients from '../locales/el/modules/clients.json';
import encrm_appointments from '../locales/en/modules/crm-appointments.json';
import elcrm_appointments from '../locales/el/modules/crm-appointments.json';
import encrm_todos from '../locales/en/modules/crm-todos.json';
import elcrm_todos from '../locales/el/modules/crm-todos.json';
import encustom_fields from '../locales/en/modules/custom-fields.json';
import elcustom_fields from '../locales/el/modules/custom-fields.json';
import enduration from '../locales/en/modules/duration.json';
import elduration from '../locales/el/modules/duration.json';
import enemail_accounts from '../locales/en/modules/email-accounts.json';
import elemail_accounts from '../locales/el/modules/email-accounts.json';
import enemail_library from '../locales/en/modules/email-library.json';
import elemail_library from '../locales/el/modules/email-library.json';
import enemail_rules from '../locales/en/modules/email-rules.json';
import elemail_rules from '../locales/el/modules/email-rules.json';
import enemail_signatures from '../locales/en/modules/email-signatures.json';
import elemail_signatures from '../locales/el/modules/email-signatures.json';
import enemails_module from '../locales/en/modules/emails-module.json';
import elemails_module from '../locales/el/modules/emails-module.json';
import enp_country from '../locales/en/modules/p_country.json';
import elp_country from '../locales/el/modules/p_country.json';
import ensearch_folders from '../locales/en/modules/search-folders.json';
import elsearch_folders from '../locales/el/modules/search-folders.json';
import entags from '../locales/en/modules/tags.json';
import eltags from '../locales/el/modules/tags.json';
import entax_authority from '../locales/en/modules/tax_authority.json';
import eltax_authority from '../locales/el/modules/tax_authority.json';
import enusers from '../locales/en/modules/users.json';
import elusers from '../locales/el/modules/users.json';

/** Module namespaces registered with i18next (`i18nKey` in module config). */
export const moduleResources = {
  en: {
    'activity-logs': enactivity_logs,
    'app_status': enapp_status,
    'client-contacts': enclient_contacts,
    'clients': enclients,
    'crm-appointments': encrm_appointments,
    'crm-todos': encrm_todos,
    'custom-fields': encustom_fields,
    'duration': enduration,
    'email-accounts': enemail_accounts,
    'email-library': enemail_library,
    'email-rules': enemail_rules,
    'email-signatures': enemail_signatures,
    'emails-module': enemails_module,
    'p_country': enp_country,
    'search-folders': ensearch_folders,
    'tags': entags,
    'tax_authority': entax_authority,
    'users': enusers,
  },
  el: {
    'activity-logs': elactivity_logs,
    'app_status': elapp_status,
    'client-contacts': elclient_contacts,
    'clients': elclients,
    'crm-appointments': elcrm_appointments,
    'crm-todos': elcrm_todos,
    'custom-fields': elcustom_fields,
    'duration': elduration,
    'email-accounts': elemail_accounts,
    'email-library': elemail_library,
    'email-rules': elemail_rules,
    'email-signatures': elemail_signatures,
    'emails-module': elemails_module,
    'p_country': elp_country,
    'search-folders': elsearch_folders,
    'tags': eltags,
    'tax_authority': eltax_authority,
    'users': elusers,
  },
} as const;

export const moduleNamespaces = Object.keys(moduleResources.en) as Array<keyof typeof moduleResources.en>;
